var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAttach = function SvgAttach(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59131 8.69748C6.89365 9.10168 7.27939 9.43613 7.72236 9.67815C8.16532 9.92016 8.65516 10.0641 9.15864 10.1001C9.66211 10.1362 10.1675 10.0635 10.6404 9.88713C11.1133 9.71071 11.5428 9.43465 11.8996 9.07766L14.0117 6.96559C14.6529 6.30168 15.0077 5.41249 14.9997 4.48953C14.9917 3.56657 14.6215 2.68368 13.9688 2.03102C13.3162 1.37836 12.4333 1.00815 11.5103 1.00013C10.5874 0.992113 9.69817 1.34692 9.03427 1.98814L7.82335 3.19202",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40757 7.28866C9.10523 6.88446 8.71949 6.55001 8.27652 6.30799C7.83356 6.06598 7.34372 5.92207 6.84024 5.88601C6.33677 5.84995 5.83142 5.92259 5.35849 6.09901C4.88555 6.27543 4.45609 6.5515 4.09923 6.90848L1.98716 9.02056C1.34594 9.68446 0.991136 10.5736 0.999157 11.4966C1.00718 12.4196 1.37738 13.3025 2.03004 13.9551C2.6827 14.6078 3.56559 14.978 4.48855 14.986C5.41152 14.994 6.30071 14.6392 6.96461 13.998L8.16849 12.7941",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttach, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attach.e84a787f.svg";
export { ForwardRef as ReactComponent };